// WCAG 1.4.3 helpers for colours that come from admin data (e.g. product status tags).

const toRgb = hex => {
	const h = hex.replace('#', '');
	const full = h.length === 3 ? [...h].map(c => c + c).join('') : h.slice(0, 6);
	return [0, 2, 4].map(i => parseInt(full.slice(i, i + 2), 16));
};

const luminance = hex =>
	toRgb(hex)
		.map(v => v / 255)
		.map(v => (v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)))
		.reduce((sum, v, i) => sum + v * [0.2126, 0.7152, 0.0722][i], 0);

export const contrastRatio = (a, b) => {
	const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
	return (hi + 0.05) / (lo + 0.05);
};

// Keeps the admin-chosen text colour when it is readable (≥ 4.5:1), otherwise falls back to black or white,
// whichever contrasts more with the background.
export const readableTextColor = (background, preferred) => {
	if (!/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(background ?? '')) return preferred;
	if (preferred && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(preferred) && contrastRatio(preferred, background) >= 4.5) return preferred;

	return contrastRatio('#000000', background) >= contrastRatio('#ffffff', background) ? '#000000' : '#ffffff';
};
